import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'https://hs.aida-advisory.com';

export default function SignupSuccess() {
  const [status, setStatus] = useState('verifying');
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');

    if (!sessionId) {
      setStatus('error');
      return;
    }

    fetch(`${API}/api/billing/verify-session/${sessionId}`)
      .then(res => {
        if (res.ok) return res.json();
        throw new Error('Session not found');
      })
      .then(data => {
        if (data.status === 'paid') {
          setStatus('success');
          setDetails(data);
        } else {
          setStatus('pending');
          setDetails(data);
        }
      })
      .catch(() => {
        setStatus('error');
      });
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white tracking-tight">
            Scheme<span className="text-blue-400">Sync</span>
          </h1>
          <p className="text-gray-400 mt-2">Commercial Real Estate Platform</p>
        </div>

        <div className="bg-gray-800 rounded-xl shadow-2xl p-8 border border-gray-700">
          {status === 'verifying' && (
            <>
              <div className="text-blue-400 text-4xl mb-4">⏳</div>
              <h2 className="text-xl font-semibold text-white mb-2">Verifying Payment...</h2>
              <p className="text-gray-400 text-sm">Please wait while we confirm your payment.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="text-green-400 text-4xl mb-4">✓</div>
              <h2 className="text-xl font-semibold text-white mb-2">Welcome to SchemeSync!</h2>
              <p className="text-gray-400 text-sm mb-2">
                Your payment was successful and your account is ready.
              </p>
              {details?.school_name && (
                <p className="text-blue-400 font-medium mb-4">{details.school_name}</p>
              )}
              <p className="text-gray-400 text-sm mb-6">
                Sign in with <span className="text-white font-medium">{details?.email}</span> and the password you chose during signup.
              </p>
              <Link
                to="/login"
                className="inline-block w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors duration-200"
              >
                Sign In Now
              </Link>
            </>
          )}

          {status === 'pending' && (
            <>
              <div className="text-yellow-400 text-4xl mb-4">⏳</div>
              <h2 className="text-xl font-semibold text-white mb-2">Payment Processing</h2>
              <p className="text-gray-400 text-sm mb-4">
                Your payment is being processed. Your account will be activated shortly. Please try signing in in a few moments.
              </p>
              <Link
                to="/login"
                className="inline-block w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors duration-200"
              >
                Go to Sign In
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="text-red-400 text-4xl mb-4">✗</div>
              <h2 className="text-xl font-semibold text-white mb-2">Something Went Wrong</h2>
              <p className="text-gray-400 text-sm mb-4">
                We couldn't verify your payment. If you were charged, your account will still be created automatically. Please try signing in or contact support.
              </p>
              <div className="space-y-3">
                <Link
                  to="/login"
                  className="inline-block w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors duration-200"
                >
                  Try Sign In
                </Link>
                <a
                  href="mailto:steven@aida-advisory.com"
                  className="inline-block w-full py-3 px-4 bg-gray-700 hover:bg-gray-600 text-gray-300 font-semibold rounded-lg transition-colors duration-200"
                >
                  Contact Support
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
